
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/typing-mentor-coach",
      function () {
        return require("private-next-pages/typing-mentor-coach.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/typing-mentor-coach"])
      });
    }
  